import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
@Injectable()
export class FireblockService {
    api_url: string = environment.apiEndPoint;

    constructor(private http: HttpClient) { }
    getToken() {
        return localStorage.getItem(environment.TOKEN_SECRET);
    }
    getFireblockVault() {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.get<any>(this.api_url + 'getfireblockvault', configs)
    }
    getFireblockAudit(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'getfireblockaudit', filter, configs)
    }
    getFireblockTransactions(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'fireblock-transactions', filter, configs)
    }
    getFireblockSyncRequest(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'fireblock-sync-request', filter, configs)
    }
    getExchangeDeposit(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'getexchangedeposit', filter, configs)
    }
    approveCancelExchangeDeposit(data: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'approve-cancel-exchange-deposit', data, configs)
    }
    getExchangeWithdraw(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'getexchangewithdrawal', filter, configs)
    }
  
    syncFireblocks(obj) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'fireblocks/sync', obj, configs)
    }
}



// WEBPACK FOOTER //
// ./src/app/fireblockvault/fireblockvault.service.ts